import {
	modalAdd
} from "./modalAdd";

export function other(productId) {
	// 変数名は型番
	// ラヴァソース&ベイキングポット
	const LV07SP = {
		rotateClass: "",
		class: "",
		cm: "7cm",
		en: "LAVA SOUFFLE OR SOUCE POT",
		jp: "ラヴァソース&ベイキングポット",
		price: "2,400",
		img: "/wp/wp-content/themes/lava/assets/img/product/other/img_souffle_pot01_other.png",
		size: "7cm",
		capacity: "0.1L",
		amount: "1人前",
		diameterText: "縦",
		diameter: "8.5cm",
		width: "14.7cm",
		height: "6.8cm",
		weight: "0.2kg",
		bottom: "4.0mm",
		edge: "3.5mm",
		number: "LV07SP",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv07sp/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv07sp.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_souffle_pot01.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	// ラヴァソース&ベイキングポット
	const LV08SP = {
		rotateClass: "",
		class: "",
		cm: "8cm",
		en: "LAVA SOUFFLE OR SOUCE POT",
		jp: "ラヴァソース&ベイキングポット",
		price: "2,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/other/img_souffle_pot02_modal.png",
		size: "8cm",
		capacity: "0.15L",
		amount: "1人前",
		diameterText: "縦",
		diameter: "8.8cm",
		width: "11.0cm",
		height: "4.5cm",
		weight: "0.4kg",
		bottom: "4.0mm",
		edge: "3.5mm",
		number: "LV08SP",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv08sp/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv08sp.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_souffle_pot02.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	// ラウンドグリドル
	const LV28GD = {
		rotateClass: "",
		class: "",
		cm: "28cm",
		en: "LAVA DUAL SIDE ROUND GRIDDLE",
		jp: "ラヴァ デュアルサイドラウンドグリドル",
		price: "7,500",
		img: "/wp/wp-content/themes/lava/assets/img/product/other/img_dual_side_round01_modal.png",
		size: "28cm",
		capacity: "―",
		amount: "4人前",
		diameterText: "縦",
		diameter: "29.3cm",
		width: "36.0cm",
		height: "2.5cm",
		weight: "4.5kg",
		bottom: "5.0mm",
		edge: "3.5mm",
		number: "LV28GD",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv28gd/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv28gd.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_dual_side_round.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	// ホットプレート
	const LV30GD = {
		rotateClass: "",
		class: "",
		cm: "30cm",
		en: "LAVA DUAL SIDE HOT PLATE",
		jp: "ラヴァ デュアルサイドホットプレート",
		price: "6,500",
		img: "/wp/wp-content/themes/lava/assets/img/product/other/img_dual_side_hot01_modal.png",
		size: "22×30cm",
		capacity: "―",
		amount: "2-3人前",
		diameterText: "直径",
		diameter: "22.2cm",
		width: "38.0cm",
		height: "1.6cm",
		weight: "4.20kg",
		bottom: "7.0mm",
		edge: "16.0mm",
		number: "LV30GD",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv30gd/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv30gd.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_dual_side_hot.jpg",
		note: "※横と高さは、蓋のツマミ、本体の取っ手を含む"
	};

	// トースター
	const LV26TS = {
		rotateClass: "",
		class: "",
		cm: "26cm",
		en: "LAVA HOT SAND MAKER",
		jp: "ラヴァ  ホットサンドメーカー",
		price: "9,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/other/img_hot_sand_maker01_modal.png",
		size: "18×26cm",
		capacity: "―",
		amount: "1-2人前",
		diameterText: "縦",
		diameter: "26.2cm",
		width: "41.7cm",
		height: "3.1cm",
		weight: "3.00kg",
		bottom: "3.5mm",
		edge: "3.0mm",
		number: "LV26TS",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv26ts/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv26ts.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_hot_sand.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	// コンボクックウェア
	const LV26CB = {
		rotateClass: "is-rotate",
		class: "",
		cm: "26cm",
		en: "LAVA COMBO CAST IRON COOKWARE",
		jp: "ラヴァ  コンボキャストアイアンクックウェア",
		price: "18,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/other/img_combo_cast01_modal.png",
		size: "26cm",
		capacity: "2.90L",
		amount: "4人前",
		diameterText: "直径",
		diameter: "27.0cm",
		width: "43.5cm",
		height: "9.5cm",
		weight: "5.37kg",
		bottom: "4.0mm",
		edge: "3.5mm",
		number: "LV26CB",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv26cb/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv26cb.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_combo.jpg",
		note: "※横と高さは、蓋のツマミ、本体の取っ手を含む"
	};

	// サービングボード
	const LV146I = {
		rotateClass: "",
		class: "",
		cm: "47cm",
		en: "LAVA WOODEN SERVICE AND CUTTING BOARD",
		jp: "ラヴァサービングボード",
		price: "5,000",
		img: "/wp/wp-content/themes/lava/assets/img/product/other/img_wooden_service01_modal.png",
		size: "15×47cm",
		capacity: "―",
		amount: "4-6人前",
		diameterText: "縦",
		diameter: "15.0cm",
		width: "60.0cm",
		height: "1.8cm",
		weight: "0.9kg",
		bottom: "―",
		edge: "―",
		number: "LV146I",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv146i/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv146i.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_wooden01.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	// サービングボード
	const LV294I = {
		rotateClass: "",
		class: "",
		cm: "―",
		en: "LAVA WOODEN SERVICE AND CUTTING BOARD",
		jp: "ラヴァサービングボード",
		price: "4,500",
		img: "/wp/wp-content/themes/lava/assets/img/product/other/img_wooden_service02_modal.png",
		size: "―",
		capacity: "―",
		amount: "1人前",
		diameterText: "縦",
		diameter: "16.0cm",
		width: "46.0cm",
		height: "1.8cm",
		weight: "0.7kg",
		bottom: "―",
		edge: "―",
		number: "LV294I",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv294i/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv294i.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_wooden02.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	// サービングボード
	const LV295I = {
		rotateClass: "",
		class: "",
		cm: "46cm",
		en: "LAVA WOODEN SERVICE AND CUTTING BOARD",
		jp: "ラヴァサービングボード",
		price: "7,500",
		img: "/wp/wp-content/themes/lava/assets/img/product/other/img_wooden_service03_modal.png",
		size: "―",
		capacity: "―",
		amount: "2人前",
		diameterText: "縦",
		diameter: "34.0cm",
		width: "46.0cm",
		height: "2.5cm",
		weight: "2.59kg",
		bottom: "―",
		edge: "―",
		number: "LV295I",
		shop01: "https://item.rakuten.co.jp/lava-japan/lv295i/",
		shop02: "https://store.shopping.yahoo.co.jp/lava/lv295i.html",
		sizeImg: "/wp/wp-content/themes/lava/assets/img/product/img_size_wooden03.jpg",
		note: "※横と高さは、本体の取っ手を含む"
	};

	switch (productId) {
		case "LV07SP": {
			modalAdd(LV07SP);
			break;
		}
		case "LV08SP": {
			modalAdd(LV08SP);
			break;
		}
		case "LV28GD": {
			modalAdd(LV28GD);
			break;
		}
		case "LV30GD": {
			modalAdd(LV30GD);
			break;
		}
		case "LV26TS": {
			modalAdd(LV26TS);
			break;
		}
		case "LV26CB": {
			modalAdd(LV26CB);
			break;
		}
		case "LV146I": {
			modalAdd(LV146I);
			break;
		}
		case "LV294I": {
			modalAdd(LV294I);
			break;
		}
		case "LV295I": {
			modalAdd(LV295I);
			break;
		}
	}
}